import React, { useState, useEffect } from 'react';
import { Navigate } from "react-router-dom";

import Grid from '@mui/material/Grid2';

import API from "@dndUtilities/system_api";

import ObjectIndex from "@components/Navigation/ObjectIndex";
import LoadingBox from "@components/input/LoadingBox";

const api = API.getInstance();

export default function CampaignIndex() {
  const [fetched, setFetched] = useState(false);
  const [logging_in, setLoggingIn] = useState(false);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  
  useEffect(() => {
    if (!fetched) {
      load();
    }
  });

  const get_true_filter = () => {
    const filter: any = {};
    const user = api.user;
    if (user) {
      filter["$or"] = [{ owner_id: user._id },{ player_ids: user._id }];
    } else {
      filter.owner_id = "No Login";
    }
    return filter;
  }
  
  const load = () => {
    if (api.user === null && api.online) {
      const userObjStr = localStorage.getItem("loginUser");
      if (!userObjStr) {
        setNavigateTo("/");
      } else {
        setLoggingIn(true);
        check_login();
      }
    }
    setFetched(true);
  }

  const check_login = () => {
    setTimeout(() => {
      if (api.user === null) {
        check_login();
      } else {
        setLoggingIn(false);
      }
    }, 1000);
  }

  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else if (logging_in) {
    return <span>Logging In</span>;
  } else if (api.user === null) {
    return <Navigate to="/" />;
  } else if (!api.online) {
    return (
      <>Campaigns unavailable when offline.</>
    );
  } else if (!fetched) {
    return (<div className="centered"><LoadingBox size={window.innerHeight * 0.5} height={window.innerHeight - 81} /></div>); // width={window.innerWidth - 17}
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <ObjectIndex 
            true_filter={get_true_filter()}
            exclude_options={["Edit"]}
            data_type="campaign"
          />
        </Grid>
      </Grid>
    ); 
  } 
}
